import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalOrderGuideCollectionsDocument = gql`
  query SalesPortalOrderGuideCollections(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getOrderGuideCollectionsForOrderEntry(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      collections {
        is_default
        linked_supplier_collection_uuid
        name
        sort_order
        type
        uuid
      }
    }
  }
`;
export function useSalesPortalOrderGuideCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalOrderGuideCollectionsQuery,
    Types.SalesPortalOrderGuideCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalOrderGuideCollectionsQuery,
    Types.SalesPortalOrderGuideCollectionsQueryVariables
  >(SalesPortalOrderGuideCollectionsDocument, options);
}
export function useSalesPortalOrderGuideCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalOrderGuideCollectionsQuery,
    Types.SalesPortalOrderGuideCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalOrderGuideCollectionsQuery,
    Types.SalesPortalOrderGuideCollectionsQueryVariables
  >(SalesPortalOrderGuideCollectionsDocument, options);
}
export type SalesPortalOrderGuideCollectionsQueryHookResult = ReturnType<
  typeof useSalesPortalOrderGuideCollectionsQuery
>;
export type SalesPortalOrderGuideCollectionsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalOrderGuideCollectionsLazyQuery
>;
export type SalesPortalOrderGuideCollectionsQueryResult = Apollo.QueryResult<
  Types.SalesPortalOrderGuideCollectionsQuery,
  Types.SalesPortalOrderGuideCollectionsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalOrderGuideCollectionsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalOrderGuideCollectionsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalOrderGuideCollectionsQuery,
    Types.SalesPortalOrderGuideCollectionsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalOrderGuideCollectionsQuery,
    Types.SalesPortalOrderGuideCollectionsQueryVariables
  >(SalesPortalOrderGuideCollectionsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalOrderGuideCollectionsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalOrderGuideCollectionsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalOrderGuideCollectionsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalOrderGuideCollectionsQuery,
    Types.SalesPortalOrderGuideCollectionsQueryVariables
  >(SalesPortalOrderGuideCollectionsDocument, lazyOptions);
}
